var site = site || {};

site.quickshop = site.quickshop || {};
(function ($) {
  MultipowerCouplesFormatterV1 = {
    formatter: $('.multi-power-couples-main-v1')
  };

  Drupal.behaviors.MultipowerCouplesFormatterV1 = {
    get: function (key) {
      return MultipowerCouplesFormatterV1[key];
    },

    set: function (key, val) {
      MultipowerCouplesFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var $rows = thisFormatter.find('.multi-power-couples-row-v1');
        var newContainer = $('.power-couples-row-anchors');

        $rows.each(function () {
          var rowID = $(this).attr('id');
          var rowTitle = $(this).attr('data-title');

          newContainer.append('<a class="cl-icon ' + rowID + '" data-attr="' + rowID + '">' + rowTitle + '</a>');
        });
        newContainer.find('.cl-icon').on('click', function () {
          var $this = $(this),
            sectionID = $this.attr('data-attr');

          $this.siblings('.active').removeClass('active');
          $this.addClass('active');
          formatter.find('.multi-power-couples-row-v1').hide();
          formatter.find('#' + sectionID).fadeIn('slow');
        });
        newContainer.find('.cl-icon').eq(0).trigger('click');
      });
      /**
     * "ADD BOTH TO BAG" functionality
    **/
      site.multiQS.startAndProcessFirstSku(context);
    }
  };
})(jQuery);
